export default __webpack_public_path__ + "static/media/leadership-involvement.4e6be59a.svg";